/** 交期排程狀態（契約：DRAFT／CONFIRMED／PARTIALLY_RECEIVED／CANCELLED 等）。 */

export const ARRIVAL_SCHEDULE_STATUS = {
  DRAFT: 'DRAFT',
  CONFIRMED: 'CONFIRMED',
  PARTIALLY_RECEIVED: 'PARTIALLY_RECEIVED',
  RECEIVED: 'RECEIVED',
  CANCELLED: 'CANCELLED',
};

export const ARRIVAL_SCHEDULE_STATUS_LABELS = {
  DRAFT: '草稿',
  CONFIRMED: '已確認',
  PARTIALLY_RECEIVED: '部分入庫',
  RECEIVED: '已入庫',
  CANCELLED: '已取消',
};

/** 寫死色票：深底淺字 */
export const ARRIVAL_SCHEDULE_STATUS_CLASS = {
  DRAFT: 'border-transparent bg-slate-600 text-slate-50',
  CONFIRMED: 'border-transparent bg-sky-600 text-sky-50',
  PARTIALLY_RECEIVED: 'border-transparent bg-violet-600 text-violet-50',
  RECEIVED: 'border-transparent bg-teal-600 text-teal-50',
  CANCELLED: 'border-transparent bg-rose-600 text-rose-50',
};

export function formatArrivalScheduleStatusLabel(status) {
  if (status == null || status === '') {
    return '—';
  }
  return ARRIVAL_SCHEDULE_STATUS_LABELS[status] ?? status;
}

/** 本 SP：DRAFT 可 cancel（契約另寫 CONFIRMED 無 receipt；本輪不做）。 */
export function canCancelDraftArrivalSchedule(status) {
  return status === ARRIVAL_SCHEDULE_STATUS.DRAFT;
}

/** 核准前 DRAFT 排程可 PATCH（須帶 updatedAt）。 */
export function canEditDraftArrivalSchedule(status) {
  return status === ARRIVAL_SCHEDULE_STATUS.DRAFT;
}

/** DRAFT → CONFIRMED；CONFIRMED／已入庫等不顯示。 */
export function canConfirmArrivalSchedule(status) {
  return status === ARRIVAL_SCHEDULE_STATUS.DRAFT;
}

/** 是否已有進貨單（一 schedule 一 WR）。 */
export function hasArrivalScheduleStockReceipt(schedule) {
  if (!schedule) {
    return false;
  }
  if (schedule.hasStockReceipt === true) {
    return true;
  }
  if (schedule.stockReceiptId) {
    return true;
  }
  if (schedule.stockReceipt?.id) {
    return true;
  }
  if (schedule.stockReceiptNo) {
    return true;
  }
  return false;
}

/**
 * CONFIRMED／PARTIALLY_RECEIVED 且尚未有進貨單可建入庫。
 * remainingQty≤0 時隱藏（若欄位缺失則仍允許，交後端 gate）。
 */
export function canReceiveArrivalSchedule(schedule) {
  const status = schedule?.status;
  const statusOk = status === ARRIVAL_SCHEDULE_STATUS.CONFIRMED
    || status === ARRIVAL_SCHEDULE_STATUS.PARTIALLY_RECEIVED;
  if (!statusOk || hasArrivalScheduleStockReceipt(schedule)) {
    return false;
  }
  const remaining = Number(schedule?.remainingQty);
  if (!Number.isNaN(remaining) && remaining <= 0) {
    return false;
  }
  return true;
}
